import { NgModule } from '@angular/core';
import { LoginPage } from './login.page';
import { LoginPageService } from './login.page.service';
import { ReactiveFormsModule } from '@angular/forms';
import { Route, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';

const routes: Route[] = [
  {
    path: 'login',
    component: LoginPage,
  },
];

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    RouterModule.forChild(routes),
  ],
  declarations: [LoginPage],
  providers: [LoginPageService],
})
export class LoginModule {}



// WEBPACK FOOTER //
// ./src/app/pages/login/login.module.ts